import scribdAuthorize from '../../scribd/scribd_oauth.js';

function SSContactsFollow(slideshare_object){
   if (typeof slideshare_object === "undefined"){
    return;
  }
  this.setup_slideview_contacts_interaction(slideshare_object);
}

SSContactsFollow.prototype.add_contact =
  function(contactee_id, success_callback, error_callback) {

  var url = "/contact/create";
  $.ajax({
    url : url,
    type : 'POST',
    dataType : 'json',
    data : {
      'contactee' : contactee_id
    },
    success : function(response) {
      if(response.suspended) {
        window.location.replace('/login');
      } else if(response.follow_limit_reached) {
        window.location.reload();
      } else {
        success_callback(response);
      }
    },
    error : error_callback
  });
};

SSContactsFollow.prototype.delete_contact =
  function(contactee_id, success_callback, fail_callback) {

  $.ajax({
    url: '/contact/delete',
    type: 'POST',
    dataType: 'json',
    data: {
      'contactee': contactee_id
    },
    success: function(resp) {
      if(resp.success) {
        success_callback(resp);
      } else {
        fail_callback(resp);
      }
    },
    error: function(resp) {
      fail_callback(resp);
    }
  });
};

SSContactsFollow.prototype.setup_slideview_contacts_interaction =
  function(slideshare_object) {

  var isWaiting = false;
  var self = this;

  /*
   * Toggle the follow/unfollow button and track events
   *
   * @param type <String> 'follow' or 'unfollow'
   * @param container <jQuery> jQuery node of follow root container
   * @param id <String> id of user to follow
   */
  var toggleContact = function(type, $container, id) {
    isWaiting = true;
    var gaValue = 'authorthumbnail>' + type;
    window._gaq.push(['_trackEvent', 'bigfoot_slideview', gaValue]);

    var successCB = function(resp) {
      $container.removeClass('loading');

      // Check if socialAPI returned true/false
      if(resp.success) {
        $container.toggleClass("following");
        $container.find('.j-follow-progress').addClass('hide')
        window._gaq.push(['_trackEvent', 'bigfoot_slideview',
          gaValue + '_failed']);
        isWaiting = false;
      } else {
        failCB();
      }
    };

    var failCB = function(resp) {
      $container.removeClass('loading');
      window._gaq.push(['_trackEvent', 'bigfoot_slideview',
        gaValue + '_failed']);
      isWaiting = false;
    };
    var checkCircleIcon = $('.check-circle-icon');

    if(type === 'follow') {
      checkCircleIcon.addClass("following");
      self.add_contact(id, successCB, failCB);
    } else if(type === 'unfollow') {
      checkCircleIcon.removeClass("following");
      self.delete_contact(id, successCB, failCB);
    }
  };

  $('.j-follow').on('click', function(e) {
    var $container = $(this);
    var contacteeId = $container.data('contactee-id');

    if (slideshare_object.user.loggedin) {
      e.preventDefault();
      var type = $container.hasClass('following') ? 'unfollow' : 'follow';

      // Ensure we only have one ajax call at a time
      if(!isWaiting) {
        $container.addClass('loading');
        $container.find('.j-follow-progress').removeClass('hide')
        toggleContact(type, $container, contacteeId);
      }
    } else {
      e.preventDefault();
      e.stopPropagation();

      var eventConfig = {
        "event": "follow",
        "data": { "contactee" : contacteeId }
      };
      slideshare_object.addAfterLoginEvent(eventConfig);
      scribdAuthorize({ from_source: window.location.pathname });
    }
  });
};

window.SSContactsFollow = SSContactsFollow;
export default SSContactsFollow;
